import { useBreakpointValue } from '@genial/utils';
import { Center } from 'native-base';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { tradingCustomerHeroDetailsQuery } from '../../../../../store/trading/selector';
import { TradingCustomerProfileItem } from '../../../../../store/trading/types';

import { CardHeroError } from './CardHeroError';
import { ContentDesktop } from './Desktop';
import { ContentMobile } from './Mobile';
import { ContentTablet } from './Tablet';

export interface CardHeroProps {
  accountId: number;
}

export interface CardHeroDataProps {
  data?: TradingCustomerProfileItem;
  isLoading: boolean;
}

export const CardHero: React.FC<CardHeroProps> = ({ accountId }) => {
  const { refresher, data, error, loading } = useRecoilQuery(
    tradingCustomerHeroDetailsQuery({ idConta: accountId })
  );

  const content = useBreakpointValue({
    base: <ContentMobile isLoading={loading} data={data?.data} />,
    sm: <ContentTablet isLoading={loading} data={data?.data} />,
    md: <ContentDesktop isLoading={loading} data={data?.data} />,
  });

  if (error) {
    return (
      <Center>
        <CardHeroError onRefresh={refresher} />
      </Center>
    );
  }

  return content;
};
